// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"header-module--wrapper--2JLn7","logo":"header-module--logo--3RSDA","nav":"header-module--nav--uyrhq","link":"header-module--link--nJ_GM"};